import { Organization } from "../model/OrganizationModel";

export function isUserOrganizationAdministrator(input: Organization, userId: string | undefined): boolean {
    if (!input) return false;

    if (userId == undefined || userId == "") return false;

    if (input?.adminUsers === undefined) return false;

    if (!input?.adminUsers?.includes(userId!)) return false;

    return true;
}

export const OrganizationHelpers = {
    UserInOrganization(org: Organization, id: string): boolean {
        if (!org || !id) return false;
        
        if (org?.adminUsers != undefined && org?.adminUsers?.includes(id)) return true;

        if (org?.ordinaryUsers != undefined && org?.ordinaryUsers?.includes(id)) return true;

        if (org?.guestUsers != undefined && org?.guestUsers?.includes(id)) return true;

        return false;
    },

    UsersAdminOrganization(org: Organization, id: string): boolean {
        if (!org || !id) return false;
        
        if (org?.adminUsers != undefined && org?.adminUsers?.includes(id)) return true;

        return false;
    }
}